import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { keys, omit } from 'lodash-es';
import { FilterPickerGroup } from 'seagull';
import { useTableListContext } from 'seagull/components/TableList/TableList.utils';
import { getTestIds } from 'seagull/utils/TestIds';
import AddFilter from '~/components/TableFilters/AddFilter/AddFilter';
import Filter from '~/components/TableFilters/Filter/Filter';
import { isInitialFilterValue, makeInitialFilterValue } from '~/components/TableFilters/TableFilters.utils';
import { SearchFilterType } from '~/components/TableFilters/types';
import { asOptions, availableFilterCount, showVerbFor } from './AgreementsFilterChips.utils';
import { MultiSelectChip } from './MultiSelectChip/MultiSelectChip';
export const GetAgreementsFilterChipsTID = (parentTestId)=>getTestIds(parentTestId);
export const AgreementsFilterChips = (param)=>{
    let { testIdPrefix, filterLabels, filterConfig, selectedFilters, filterGroups, onRefresh, setSelectedFilters } = param;
    const { sort } = useTableListContext();
    const { AgreementsFilterChipsTestIds } = useMemo(()=>GetAgreementsFilterChipsTID(testIdPrefix), [
        testIdPrefix
    ]);
    const visibleFilterKeys = keys(selectedFilters);
    const onChange = (filter, value)=>{
        const next = _object_spread_props(_object_spread({}, selectedFilters), {
            [filter]: value
        });
        onRefresh(next, sort);
        setSelectedFilters(next);
    };
    const onRemove = (filter)=>{
        const value = selectedFilters[filter];
        const next = omit(selectedFilters, filter);
        if (!isInitialFilterValue(value, filterConfig[filter])) onRefresh(next, sort);
        setSelectedFilters(next);
    };
    const onSelect = (filter)=>{
        setSelectedFilters(_object_spread_props(_object_spread({}, selectedFilters), {
            [filter]: makeInitialFilterValue(filterConfig[filter])
        }));
    };
    return /*#__PURE__*/ _jsxs(FilterPickerGroup, {
        flexWrap: true,
        testId: AgreementsFilterChipsTestIds.Group(),
        children: [
            visibleFilterKeys.map((filter)=>{
                var _selectedFilters_filter;
                const config = filterConfig[filter];
                if (config.type === SearchFilterType.MultiSelectFilter) {
                    var _selectedFilters_filter1;
                    return /*#__PURE__*/ _jsx(MultiSelectChip, {
                        testId: AgreementsFilterChipsTestIds.Chip(filter),
                        fieldLabel: filterLabels[filter],
                        showVerb: showVerbFor(filter),
                        options: asOptions(config),
                        value: (_selectedFilters_filter1 = selectedFilters[filter]) !== null && _selectedFilters_filter1 !== void 0 ? _selectedFilters_filter1 : [],
                        onChange: (next)=>onChange(filter, next),
                        onRemove: ()=>onRemove(filter),
                        biPrefix: "agreements_chip_".concat(filter)
                    }, String(filter));
                }
                return /*#__PURE__*/ _jsx(Filter, {
                    label: filterLabels[filter],
                    filter: filter,
                    selectedFilter: (_selectedFilters_filter = selectedFilters[filter]) !== null && _selectedFilters_filter !== void 0 ? _selectedFilters_filter : makeInitialFilterValue(config),
                    testIdPrefix: testIdPrefix,
                    onChange: (value)=>onChange(filter, value),
                    onRemove: ()=>onRemove(filter),
                    filterConfig: config
                }, String(filter));
            }),
            keys(selectedFilters).length < availableFilterCount(filterGroups, filterConfig) && /*#__PURE__*/ _jsx(AddFilter, {
                filtersMap: filterLabels,
                testId: testIdPrefix,
                selectedFilters: keys(selectedFilters),
                onSelect: onSelect,
                groups: filterGroups
            })
        ]
    });
};
